import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Input, Checkbox } from 'react-toolbox';
import cx from 'classnames';
import PhoneInput from 'components/PhoneType/PhoneInput';
import StyledSelect from 'components/StyledSelect';
import FlexBox from 'flexbox-react';
import styles from 'styles/form';
import { nestedError } from '../../../../../utils';
import { can } from '../../../../../services';
import ColoredButton from 'components/ColoredButton';
import RTCheckbox from 'styles/checkbox.scss';

import { STORE_CONTACT_POSITIONS } from 'config/constants';

const largeInput = cx(styles.childInputs, styles.largeInput);

class StoreContactForm extends Component {
  constructor(props) {
    super(props);
    this.onNameChange = this.props.onChange.bind(this, 'name');
    this.onPhoneChange = this.props.onChange.bind(this, 'phone_number');
    this.onEmailChange = this.props.onChange.bind(this, 'email');
    this.onPositionChange = this.props.onChange.bind(this, 'position');
    this.onInstallationUpdatesChange = this.props.onChange.bind(this, 'installation_updates');
    this.onAssessmentUpdatesChange = this.props.onChange.bind(this, 'assessment_updates');
    this.onEmailOptInChange = this.props.onChange.bind(this, 'email_opt_in');
    this.showError = nestedError.bind(this, 'store_contacts', this.props.index);
  }

  render = () => {
    const { errors, storeContact, index, onDelete, role } = this.props;
    const canDeleteContact = can(role, 'delete', 'store_contact');
    return (<div className={styles.childCard}>
      <FlexBox className={styles.childDivider}>
        <Input
          label="Name"
          value={storeContact.name}
          className={largeInput}
          error={this.showError('name', errors)}
          required
          onChange={this.onNameChange}
        />
        <PhoneInput
          label="Phone Number"
          type="tel"
          value={storeContact.phone_number}
          className={largeInput}
          error={this.showError('phone_number', errors)}
          onChange={this.onPhoneChange}
        />
        <Input
          label="Email Address"
          value={storeContact.email}
          className={largeInput}
          error={('emailError' in storeContact && storeContact.emailError) ?
            'Input Valid Email' : this.showError('email', errors)}
          required
          onChange={this.onEmailChange}
        />
        <StyledSelect
          className={largeInput}
          label="Position"
          placeholder="Select Position"
          options={STORE_CONTACT_POSITIONS.map(scp => ({ value: scp, label: scp }))}
          value={storeContact.position}
          error={this.showError('position', errors)}
          onChange={this.onPositionChange}
          required
        />
      </FlexBox>
      <h5 className={styles.childTitle}>Report Preferences</h5>
      <FlexBox flex="1">
        <Checkbox
          checked={storeContact.installation_updates}
          label="Daily Installation Updates"
          onChange={this.onInstallationUpdatesChange}
          className={styles.checkboxListItem}
          theme={RTCheckbox}
        />
        <Checkbox
          checked={storeContact.assessment_updates}
          label="Daily Assessment Updates"
          onChange={this.onAssessmentUpdatesChange}
          className={styles.checkboxListItem}
          theme={RTCheckbox}
        />
        <Checkbox
          checked={storeContact.email_opt_in}
          label="Email Opt-In"
          onChange={this.onEmailOptInChange}
          className={styles.checkboxListItem}
          theme={RTCheckbox}
        />
      </FlexBox>
      {canDeleteContact && <ColoredButton
        className={styles.deleteChildButton}
        color="red"
        label="Delete store contact"
        onClick={() => onDelete(index)}
      />}
    </div>);
  }
}

StoreContactForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  errors: PropTypes.object,
  storeContact: PropTypes.shape({
    name: PropTypes.string,
    phone_number: PropTypes.string,
    email: PropTypes.string,
    position: PropTypes.string,
    installation_updates: PropTypes.bool,
    assessment_updates: PropTypes.bool,
  }),
  index: PropTypes.number,
  role: PropTypes.string.isRequired,
};

export default StoreContactForm;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/stores/components/storeContactForm.jsx